<script lang="ts">
    import { kgToLb } from "@/Util/utils";
    import { LocalDate } from "@/time";

    export let root: HTMLElement;
    export let date;
    export let notes;

    //@ts-ignore
    const Xert = window.Xert

    let displayUnits = Xert._displayUnits;
    let _date = LocalDate.format(date);
    let todays_notes;

    $: {
        if (notes && notes[_date]) {
            todays_notes = notes[_date];
        }
        else {
            todays_notes = {
                'notes': '',
                'update_weight': false,
                'weight': 0
            };
        }
    }

    function dispatchNotesUpdate() {
        let event = new CustomEvent("showNotesUpdate", {
            bubbles: true,
            detail: {
                date
            }
        });
        if (root) root.dispatchEvent(event);
    }
</script>

<div class="note-card" hidden={!todays_notes.notes?.length && !todays_notes.update_program && !todays_notes.update_freshness && !todays_notes.update_weight}>
    <div class="row-programType">
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <i class="fa-thin fa-lg fa-calendar-lines-pen" style="font-size: 16px;" on:click={dispatchNotesUpdate}/>
        <div class="program-text">
            {#if todays_notes.update_program || todays_notes.update_freshness || todays_notes.update_weight}
            Scheduled Update
            {:else}
            Notes
            {/if}
        </div>
    </div>
    <div class="row-noteSnippet" class:hidden={!todays_notes.notes?.length}>
        <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{todays_notes.notes}</div>
    </div>
    <hr hidden={!(todays_notes.notes?.length > 0 && (todays_notes.update_freshness || todays_notes.update_weight) && !todays_notes.update_program)}>
    <div class="row-statuses" class:hide={!todays_notes.update_freshness && !todays_notes.update_weight}>
        {#if todays_notes.update_weight}
        <div class="status-container" class:hide={!todays_notes.update_weight}>
            <div>Weight: {Number.parseFloat(displayUnits == "imperial" ? kgToLb(todays_notes.weight) : todays_notes.weight).toFixed(1)} {displayUnits == "imperial" ? "lb" : "kg"}</div>
        </div>
        {/if}
    </div>
</div>

<style lang="scss">
    .note-card {
        width: 100%;
        padding: 8px;
        background: #f2f2f2;
        .fa-calendar-lines-pen:hover {
            cursor: pointer;
            opacity: 0.8;
        }
        [class*=row] {
            display: flex;
            align-content: center;
            margin-top: 5px;
            &[class*=programType] {
                margin-top: 0px;
                max-height: 26px;
                justify-content: left;
                align-items: center;
                gap: 6px;
            }
            &[class*=noteSnippet] {
                font-size: 10px;
                display: block;
                overflow: hidden;
            }
            &[class*=tags] {
                gap: 4px;
                flex-wrap: wrap;
            }
            &[class*=statuses] {
                flex-direction: column;
            }
            &.hide {
                display: none;
            }
        }
        .program-text {
            font-size: 12px; 
            line-height: 12px; 
            font-weight: 600;
        }
        .pillbox-tag {
            font-size: 10px;
            padding: 4px 8px;
            border-radius: 90px;
            background: grey;
            color: black;
            &.green {
                background: #7ED32133;
                color: #5CA907;
            }
            &.indigo {
                background: #2F707633; 
                color: #2F7076;
            }
            &.yellow {
                background: #FFB90080;
                color: #8F6800;
            }
            &.blue {
                background: #4A90E233;
                color: #0B5DBC;
            }
            &.grey {
                background: #3D3D3D33;
                color: #3D3D3D;
            }
        }
        .status-container {
            font-size: 10px;
            font-weight: 400;
            &.hide {
                display: none;
            }
        }
        hr {
            margin: 8px 0px;
            border: 1px solid #d5d5d5;
            color: #d4d4d4;
        }
    }
</style>